<template>
    <div class="p-2" style="width:250px">
      <form-label>{{$t('GradeControl.Equipment.Name')}}</form-label>
      <v-select
        label="code"
        :options="equipments"
        :reduce="equipment => equipment.equipmentId"
        v-model="equipmentId"
        @input="setSelected"
        class="w-full"
        name="equipmentCode">
        <template #option="{ code, company }">
          {{ code }} - {{ company }}
        </template>
      </v-select>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { FormLabel } from "../../../shared/components";

export default {
  name: 'CellEditorEquipments',
  data() {
    return {
      equipmentId: null
    }
  },
  computed: {
    equipments() {
      return this.params.context.componentParent.equipments;
    }
  },
  components: {
    'v-select': vSelect,
    FormLabel
  },
  created() {
    this.equipmentId = this.params.value.equipmentId;
  },
  methods: {
    getValue() {
      return this.equipmentId
    },
    isPopup() {
      return true;
    },
    setSelected(id) {
      this.equipmentId = id;
      this.params.api.stopEditing();
    }
  }
}
</script>
